import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import BlockForm from '../../Admin/Pages/Blocks/BlockForm'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faCog } from '@fortawesome/pro-duotone-svg-icons/faCog'
import { CompactButton } from '@/shared/ui/buttons'

export default class BlockEditButton extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            edit: false,
        }
    }

    render() {
        const kedo = this.props.kedo

        return (
            <>
                {this.state.edit ? (
                    <BlockForm
                        variant={'edit'}
                        item={this.props.item}
                        kedo={kedo}
                        handleClose={this.props.handleClose}
                        onClose={() => this.setState({ edit: false })}
                        onSuccess={() => {
                            this.setState({ edit: false })
                            this.props.onSuccess()
                        }}
                    />
                ) : null}
                <CompactButton
                    size={this.state.size}
                    dense={this.state.size === 'sm'}
                    sx={{ float: 'right' }}
                    onClick={() => this.setState({ edit: true })}
                >
                    <FontAwesomeIcon icon={faCog} />
                </CompactButton>
            </>
        )
    }
}
